import React, { useState } from 'react';
import CardSection from '../CardSection/CardSection';
import { states, countries } from '../Utils/LocationData.js'
import './CardModal.scss';
import { injectStripe } from 'react-stripe-elements'
function CardModal(props) {
  const [name, setName] = useState(props.card.name || '');
  const [address_line1, setAddress_1] = useState(props.card.address_line1 || '');
  const [address_line2, setAddress_2] = useState(props.card.address_line2 || '');
  const [address_city, setCity] = useState(props.card.address_city || '');
  const [address_state, setState] = useState(props.card.address_state || '');
  const [address_country, setCountry] = useState(props.card.address_country || 'US');
  const [address_zip, setZipcode] = useState(props.card.address_zip || '');
  const [exp_month, setMonth] = useState(props.card.exp_month || '');
  const [exp_year, setYear] = useState(props.card.exp_year || '');
  const [fieldsError, setFieldsError] = useState('');
  const [expDateError, setExpDateError] = useState('');
  const [enableAddBtn, setEnableAddBtn] = useState(true);
  // const [invalidExpDateError, setInvalidExpDateError] = useState('');
  const [markDefault, setMarkDefault] = useState(props.card.default_source || false);
  function addCard() {
    setFieldsError('');
    if(!name || !address_line1 || !address_city || !address_state || !address_country || !address_zip) {
      setFieldsError('Please completed required fields');
      return;
    }
    let data = {
      name,
      address_line1,
      address_line2,
      address_city,
      address_state,
      address_country,
      address_zip
    };
    props.addCard(data);
  }

  function setDefaultCard() {
    let data = {
      stripeId: props.stripeId,
      cardId: props.card.id
    };
    if(props.card.name) {
      if(window.confirm(`Set ${props.card.name}'s card ending in ${props.card.last4} to the default card?`)) {
        props.setAsDefault(data);
      }
    } else {
      if(window.confirm(`Set this card to the default card?`)) {
        props.setAsDefault(data);
      }
    }
  }

  function deleteCard() {
    let data = {cardId: props.card.id, stripeId: props.stripeId}
    if(!props.card.default_source) {
      if(window.confirm(`are you sure you want to delete ${props.card.name + "'s" || "No Name's"} card?`)){
        props.deleteCard(data);
        props.close(false);
      }
    } else {
      alert('Card cannot be deleted because it is the default source.');
    }
  }

  function updateCard() {
    setFieldsError('');
    setExpDateError('');
    if(!name || !address_line1 || !address_city || !address_state || !address_country || !address_zip || !exp_month || !exp_year) {
      setFieldsError('Please completed required fields');
      return;
    }
    const currentYear = new Date().getFullYear().toString().substr(-2);
    const currentMonth = new Date().getMonth().toString().substr(-2);
    let data = {
      fields: {
        name,
        address_line1,
        address_line2,
        address_city,
        address_state,
        address_country,
        address_zip,
        exp_month,
        exp_year
      },
      card_id: props.card.id
    };

    let month = exp_month.toString().substr(-2);
    let year = exp_year.toString().substr(-2);
    if(parseInt(month) === 0 || parseInt(year) === 0) {
      setExpDateError('Invalid expire date');
      return;
    }
    
    if ((month >= currentMonth && month <= 12) && year >= currentYear) {
      props.updateCard(data);
      if(markDefault && !props.card.default_source) {
        setDefaultCard();
      }
      props.close(false);
      return;
    }

    if(month < currentMonth && year > currentYear) {
      props.updateCard(data);
      if(markDefault && !props.card.default_source) {
        setDefaultCard();
      }
      props.close(false);
      return;
    }

    if(year < currentYear) {
      setExpDateError('Invalid expire date');
      return;
    }

    if(month < currentMonth && year < currentYear) {
      setExpDateError('Invalid expire date');
      return;
    } 
  }

  function closeModal() {
    if(props.action === 'add') {
      props.close(false);
    } else if(props.action === 'update') {
      props.close({});
    }
  }

  const onCardUpdate = function(isValid){
    setEnableAddBtn(isValid);
    console.log(isValid);
  }

  return (
        <div className="modal-container">
          <div className="modal-content">
            <div className="close-container">
              <img src={require('../assets/close.png')} alt="" className="close" onClick={closeModal}/>
            </div>
            <div className="modal-header">
            <div className="back-container">
              <div className="back" onClick={closeModal}></div>
            </div>
              <div className="title">Card Info</div>
            </div>
            {expDateError && !fieldsError && <div className="error">{expDateError}</div>}
            {props.error && !fieldsError && <div className="error">{props.error}</div>}
            {fieldsError && <div className="error">{fieldsError}</div>}
            <div className="inputs-container">
              <div className="input-container">
                <div className="label">Name <div style={{color: "red"}}>*</div></div>
                <input type="text" placeholder="" className="input" value={name} onChange={e => setName(e.target.value)}/>
              </div>
              <div className="divided-inputs">
                <div className="input-container-divided">
                  <div className="label">Address 1 <div style={{color: "red"}}>*</div></div>
                  <input type="text" value={address_line1} onChange={e => setAddress_1(e.target.value)} className="input"/>
                </div>
                <div className="input-container-divided">
                  <div className="label">Address 2</div>
                  <input type="text" value={address_line2} onChange={e => setAddress_2(e.target.value)} className="input"/>
                </div>
              </div>
              <div className="divided-inputs">
                <div className="input-container-divided">
                  <div className="label">City <div style={{color: "red"}}>*</div></div>
                    <input type="text" value={address_city} onChange={e => setCity(e.target.value)} className="input" />
                  </div>
                <div className="input-container-divided">
                  <div className="label">State <div style={{color: "red"}}>*</div></div>
                  <select value={address_state} onChange={e => setState(e.target.value)}>
                    {states.map((state, key) => {
                      return <option key={key} value={state}>{state}</option>;
                    })}
                  </select>
                </div>
              </div>

              <div className="divided-inputs">
                <div className="input-container-divided">
                  <div className="label">Country <div style={{color: "red"}}>*</div></div>
                  <select value={address_country} onChange={e => setCountry(e.target.value)}>
                    {countries.map((country, key) => {
                      return <option key={key} value={country.code}>{country.name}</option>;
                    })}
                  </select>
                </div>
                <div className="input-container-divided">
                  <div className="label">Zipcode <div style={{color: "red"}}>*</div></div>
                  <input maxLength="5" type="text" value={address_zip} onChange={e => setZipcode(e.target.value)} className="input"/>
                </div>
              </div>
              <div className="divided-inputs">
                {props.action === 'add' && <CardSection onCardUpdate= {onCardUpdate}  />}
              </div>
              {props.action === 'update' && (
                <div className="divided-inputs">
                  <div className="input-container-divided">
                    <div className="label">Exp Month <div style={{color: "red"}}>*</div></div>
                    <input maxLength="2" type="text" value={exp_month} onChange={e => setMonth(e.target.value)} className="input"/>
                  </div>
                  <div className="input-container-divided">
                    <div className="label">Exp Year <div style={{color: "red"}}>*</div></div>
                    <input maxLength="4" type="text" value={exp_year} onChange={e => setYear(e.target.value)} className="input"/>
                  </div>
                </div>
              )}
              {
                !props.card.default_source && props.action !== 'add' && (
                  <div className="set-default-card">
                    <div className="box-container" onClick={()=>{setMarkDefault(!markDefault)}}><div className="box" style={{backgroundColor: markDefault ? '#353250' : 'white'}}></div></div>
                    <div className="default-title">Set Primary</div>
                  </div>
                )
              }
            </div>
            {props.action === 'add' ? (
              <div className="update-info-button-container" style={enableAddBtn? styles.divEnable: styles.divDisable}>
                  <div ontouchstart="" className="update-info-button" onClick={() => {addCard();}}>Add Card</div>
              </div>
                ) : (
                  <div className="actions-container">
                  <div className="card-button-delete" onClick={()=>{deleteCard()}}>Delete Card</div>
                  <div className="card-button" onClick={() => {updateCard();}}>Update Card</div>
                </div>
              )}
          </div>
        </div>
  );
}

const styles = {
  divDisable:{
    opacity: 0.5,
    pointerEvents: "none"
  },
  divEnable:{
    pointerEvents: "auto"
  }
  
}

export default injectStripe(CardModal);
